import { useEffect, useState } from 'react';
import * as am4core from '@amcharts/amcharts4/core';
import * as am4charts from '@amcharts/amcharts4/charts';
import am4themes_animated from '@amcharts/amcharts4/themes/animated';
import { Skeleton } from '@mui/material';
import { Stack } from '@mui/material';
import {useTranslation} from "react-i18next";

am4core.useTheme(am4themes_animated);

const ChartSeven = ({ data, name, className }) => {
    const [showLoader, setShowLoader] = useState(false);
    const { t } = useTranslation();

    useEffect(() => {
        // Create chart instance
        let chart = am4core.create(name, am4charts.XYChart);
        const colors = [
            am4core.color("#6794dc"),
            am4core.color("#dc6967"),
            am4core.color("#FFA500"),
        ];

        chart.events.on('ready', () => {
            setShowLoader(false);
        });

        // Add data
        chart.data = data['data'];
        let legend = data['legend'];

        // Create axes
        let categoryAxis = chart.xAxes.push(new am4charts.CategoryAxis());
        categoryAxis.dataFields.category = "year";
        categoryAxis.renderer.grid.template.location = 0;
        categoryAxis.renderer.minGridDistance = 15;

        let valueAxis = chart.yAxes.push(new am4charts.ValueAxis());
        valueAxis.renderer.inside = true;
        valueAxis.renderer.labels.template.disabled = true;
        valueAxis.min = 0;
        valueAxis.extraMax = 0.15;
        valueAxis.renderer.labels.template.disabled = false;
        valueAxis.renderer.inside = false;
        valueAxis.title.text = t('LOCAL_INDICATORS.IN_MILLION_ALL');

        createSeries("revenue_from_taxes", legend['revenue_from_taxes'], colors[0], 'revenue_from_taxes_percentage');
        createSeries("revenue_from_fees", legend['revenue_from_fees'], colors[1], 'revenue_from_fees_percentage');
        createSeries("revenue_from_non_fiscal", legend['revenue_from_non_fiscal'], colors[2], 'revenue_from_non_fiscal_percentage');

        // Create series
        function createSeries(field, name, color, percentage) {
            // Set up series
            let series = chart.series.push(new am4charts.ColumnSeries());
            series.name = name;
            series.dataFields.valueY = field;
            series.dataFields.categoryX = "year";
            series.sequencedInterpolation = true;
            series.fill = color; // Set the fill color for this series
            series.stroke = color; // Set the stroke color for this series
            // Make it stacked
            series.stacked = true;

            // Configure columns
            series.columns.template.width = am4core.percent(60);
            series.columns.template.tooltipText = `[bold]{name}[/]\n[font-size:14px]{categoryX}: {valueY} ({${percentage}}%)`;

            // Add label
            let labelBullet = series.bullets.push(new am4charts.LabelBullet());
            labelBullet.label.text = "{valueY}";
            labelBullet.locationY = 0.5;
            labelBullet.label.hideOversized = true;

            return series;
        }

        // Legend
        chart.legend = new am4charts.Legend();

        chart.exporting.menu = new am4core.ExportMenu();
        chart.exporting.menu.align = 'left';
        chart.exporting.menu.verticalAlign = 'top';

    }, []);

    return (
        <>
            <div style={{ display: 'flex', gap: '20px' }}>
                {/* Chart container */}
                <div id={name} style={{width: showLoader ? '0' : '100%', height: showLoader ? '0' : '700px'}} className={className}></div>
            </div>

            {showLoader && (
                <Stack spacing={1}>
                <Skeleton variant='text' />
                    <Skeleton variant='rounded' width={'auto'} height={500} />
                </Stack>
            )}
        </>
    );
};

export default ChartSeven;


